import {
  Component,
  OnInit,
  EventEmitter,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Veiculo } from '../../model/veiculo';
import { VeiculoSimulacao } from '../model/proposta/veiculo-simulacao';

@Component({
  selector: 'app-modal-edit-veiculo',
  templateUrl: './modal-edit-veiculo.component.html',
  styleUrls: ['./modal-edit-veiculo.component.scss'],
})
export class ModalEditVeiculoComponent implements OnInit {
  @Input() mapForSave: boolean;
  @Input() veiculo: VeiculoSimulacao;
  @Input() veiculos: VeiculoSimulacao[] = [];
  mapVeiculo: Veiculo;
  mapVeiculos: Veiculo[];

  alive: boolean = true;
  onSave: EventEmitter<any> = new EventEmitter();
  isFormValid: boolean;
  isVeiculoAlterado: boolean;
  veiculoAlterado: Veiculo;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.mapVeiculo = this.mapVeiculoForEdit(this.veiculo);
    this.mapVeiculos = this.veiculos.map(this.mapVeiculoForEdit);
  }

  private mapVeiculoForEdit(veiculo: VeiculoSimulacao): Veiculo {
    const {
      placa,
      uf,
      categoria,
      marca,
      anoModelo,
      modelo,
      versao,
      utilizacaoAgropecuaria,
      zero,
      cotacao,
    } = veiculo;

    if (placa) {
      return {
        veiculoPlaca: placa,
        ufLicenciamento: uf,
        isUtilizacaoAgropecuaria: utilizacaoAgropecuaria,
        saved: true,
      };
    }

    return {
      cotacao,
      veiculoPlaca: placa,
      ufLicenciamento: uf,
      veiculoCategoria: categoria.getId(),
      veiculoMarca: { id: marca.getId(), descricao: marca.getDescricao() },
      veiculoAno: anoModelo,
      veiculoModelo: { id: modelo.getId(), descricao: modelo.getDescricao() },
      veiculoVersao: { id: versao.getId(), descricao: versao.getDescricao() },
      isUtilizacaoAgropecuaria: utilizacaoAgropecuaria,
      isZeroKm: zero,
      saved: true,
    };
  }

  private mapVeiculoForSave(veiculo: Veiculo): any {
    const {
      ufLicenciamento,
      isUtilizacaoAgropecuaria,
      isZeroKm,
      veiculoPlaca,
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
    } = veiculo;

    if (!isZeroKm) {
      return {
        placa: veiculoPlaca,
        uf: ufLicenciamento,
        utilizacaoAgropecuaria: isUtilizacaoAgropecuaria,
      };
    }

    return {
      anoModelo: veiculoAno,
      categoria: { id: veiculoCategoria },
      marca: { id: veiculoMarca.id, descricao: veiculoMarca.descricao },
      modelo: { id: veiculoModelo.id, descricao: veiculoModelo.descricao },
      versao: { id: veiculoVersao.id, descricao: veiculoVersao.descricao },
      fipe: veiculoVersao ? veiculoVersao.codigoMolicar : undefined,
      condicao: veiculo['inserirManual'] ? 'USADO' : isZeroKm ? 'ZERO' : 'USADO',
      uf: ufLicenciamento,
      utilizacaoAgropecuaria: isUtilizacaoAgropecuaria,
    };
  }

  private verificaSeAlterou(veiculo: Veiculo): boolean {
    const campos = [
      'veiculoPlaca',
      'ufLicenciamento',
      'veiculoCategoria',
      'veiculoMarca',
      'veiculoAno',
      'veiculoModelo',
      'veiculoVersao',
      'isUtilizacaoAgropecuaria',
      'isZeroKm',
    ];

    return campos.some((campo) => {
      const mapId = (this.mapVeiculo[campo] && this.mapVeiculo[campo].id) || -2;
      const id = (veiculo[campo] && veiculo[campo].id) || -2;
      const result =
        ((this.mapVeiculo[campo] || veiculo[campo]) &&
          mapId === id &&
          this.mapVeiculo[campo] !== veiculo[campo]) ||
        mapId !== id;
      return result;
    });
  }

  public changeForm(form: FormGroup): void {
    this.isVeiculoAlterado = this.verificaSeAlterou(form.value);
    this.veiculoAlterado = form.value;
  }

  public changeFormValid(isValid: boolean): void {
    this.isFormValid = isValid;
  }

  save() {
    const veiculo = this.mapForSave
      ? this.mapVeiculoForSave(this.veiculoAlterado)
      : this.veiculoAlterado;
    this.onSave.emit(veiculo);
    this.close();
  }

  close() {
    this.alive = false;
    this.bsModalRef.hide();
  }
}
